<template>
	<section>
		<MainLayout>
			<div class="container">
				<div class="box text-center">
					<h2 class="my-4">
						Hola
						<strong class="text-muted">{{ user.firstName }}!</strong>
					</h2>
					<h3 class="text-muted mb-5">Bienvenido</h3>
					<div class="container mt-5">
						<b-avatar
							size="200px"
							variant="primary"
							:text="user.firstName.charAt(0)"
						></b-avatar>
					</div>
				</div>
			</div>
		</MainLayout>
	</section>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";
export default {
	components: {
		MainLayout
	},
	computed: {
		user() {
			return this.$root.store.state.currentUser;
		}
	}
};
</script>

<style scoped>
.hello {
	width: 500px;
	height: auto;
}
.container {
	max-width: 600px;
}

</style>
<style>
	/* Animation property */
.__shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>
